import React from "react";
import { Link } from "react-router-dom";
import { EntryBrand, EntryIcon } from "./PublicEntryUI";

// # PUBLIC AUTH: login and registration share one visual shell. Keep the
// public entrance light and legible, independently of dashboard preferences.
// This component owns presentation only; each page keeps its existing API flow.
export default function PublicAuthLayout({
  homeHref = "/",
  accountHref,
  accountPrompt,
  accountLabel,
  eyebrow,
  title,
  titleId,
  subtitle,
  storyEyebrow,
  storyTitle,
  storyDescription,
  benefits = [],
  storyNote,
  children,
}) {
  return (
    <div className="wp-entry wp-signup">
      <header className="wp-entry-container wp-signup-header">
        <EntryBrand to={homeHref} />
        <div>
          <span>{accountPrompt}</span>
          <Link className="wp-entry-login" to={accountHref}>
            {accountLabel}
            <EntryIcon size={17} />
          </Link>
        </div>
      </header>
      <main className="wp-entry-container wp-signup-main">
        <aside className="wp-signup-story" aria-label="Tu espacio en WebProfit">
          <p className="wp-entry-eyebrow">{storyEyebrow}</p>
          <h2>{storyTitle}</h2>
          <p>{storyDescription}</p>
          <ul className="wp-signup-benefits">
            {benefits.map((benefit) => (
              <li key={benefit}>
                <EntryIcon name="check" size={18} />
                {benefit}
              </li>
            ))}
          </ul>
          {storyNote && <p className="wp-signup-story-note">{storyNote}</p>}
        </aside>
        <section className="wp-signup-card" aria-labelledby={titleId}>
          <Link className="wp-signup-back" to={homeHref}>
            <EntryIcon name="back" size={15} />
            Volver al inicio
          </Link>
          <p className="wp-entry-eyebrow">{eyebrow}</p>
          <h1 id={titleId}>{title}</h1>
          <p className="wp-signup-intro">{subtitle}</p>
          {children}
        </section>
      </main>
      <footer className="wp-entry-container wp-signup-footer">
        <span>WebProfit · Tu negocio, en un solo lugar.</span>
        <span>© {new Date().getFullYear()} WebProfit</span>
      </footer>
    </div>
  );
}
